import { useNavigate } from "react-router-dom";
import "./Css/ExamCreateForm.css";
import { useState } from "react";


const CreateBook = () => {
      const navigate = useNavigate();
      const [showPopup, setShowPopup] = useState(false);


  return (
    <div className="create-exam-wrapper">
     <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          पुस्तक व्यवस्थापन &gt;&gt; <span>पुस्तक खरेदी नोंद जोडा</span>
        </h3>

        <div className="edit-btnn">
    
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
         <button
  className="btn primaryy"
onClick={() => navigate(-1)}
>
  सेव्ह करा 
</button>

        </div>
      </div>

      {/* Form */}
      <div className="create-exam-form">
         <h2>पुस्तक खरेदी नोंद करा</h2>
        <div className="form-grid">
            
          <div className="form-group">
            <label>पुस्तकाचं नाव</label>
            <input placeholder="पुस्तकाचं नाव" />
          </div>
                <div className="form-group">
            <label>विद्यार्थ्याचं नाव</label>
            <input placeholder="विद्यार्थ्याचं नाव" />
          </div>
          <div className="form-group">
            <label>पेमेंट तारीख</label>
            <input type="date" />
          </div>

          <div className="form-group">
            <label>किंमत ₹</label>
            <input type="text" placeholder="₹" />
          </div>

          <div className="form-group">
            <label>कमिशन %</label>
            <select>
                <option>कमिशन %</option>
                <option>10</option>
                <option>20</option>
                <option>30</option>
            </select>
          </div>
           <div className="form-group">
            <label>पेमेंट स्थिती </label>
            <select>
                <option>कमिशन %</option>
                <option>जमा</option>
                <option>बाकी</option>
            </select>
          </div>
    
         </div>
      </div>

    </div>
  );
};

export default CreateBook;
